import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  featureCarouselContent,
  overviewCopyImageSectionOne,
  overviewCopyImageSectionTwo,
  heroContent,
  videoContent,
} from 'components/MarketingPro/data/marketingProOverviewData';
import { subNavData } from 'components/MarketingPro/data/subNavData';
import SEO, { createSEO } from 'components/SEO';
import WebsiteLayout from 'layouts/websiteLayout';
import SubNav from 'components/MarketingPro/MarketingProSubNav';
import MarketingProHero from 'components/MarketingPro/MarketingProHero';
import MarketingProRowContent from 'components/MarketingPro/MarketingProRowContent';
import MarketingProRowContentCarousel from 'components/MarketingPro/MarketingProRowContentCarousel';
import MarketingProOverviewVideo from 'components/MarketingPro/MarketingProOverviewVideo';
import MarketingProValueProp from 'components/MarketingPro/MarketingProValueProp';
import MarketingProOverviewStats from 'components/MarketingPro/MarketingProOverviewStats';
import RowContent from 'components/RowContent';
import useBreakpoint from 'utils/useBreakpoint';
import useMarketingProOverviewData from 'components/MarketingPro/hooks/useMarketingProOverviewData';
import useGlobalHeader from 'hooks/useGlobalHeader';
import useGlobalFooter from 'hooks/useGlobalFooter';
import generateBreadcrumbs from '../../utils/getBreadcrumbData';
import Breadcrumbs from '../../components/Breadcrumbs';

const MarketingProOverview = props => {
  const {
    bottomForm,
    hero,
    heroInlineMarketingForm,
    seo,
    statsGraph,
    valuePropBackground,
  } = useMarketingProOverviewData();
  const pageSeo = createSEO(seo, props);
  const [stickyHeader, setStickyHeader] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const featureCarouselContentData = featureCarouselContent();
  const overviewCopyImageSectionOneData = overviewCopyImageSectionOne();
  const overviewCopyImageSectionTwoData = overviewCopyImageSectionTwo();
  const subNavForm = hero?.contextualCta[0]?.onFormSubmissionModalMarketoForm;
  const videoData = videoContent();
  const breakpoint = useBreakpoint();
  const isMobile =
    breakpoint?.breakpoint === 'xs' ||
    breakpoint?.breakpoint === 'sm' ||
    breakpoint?.breakpoint === 'md';
  const header = useGlobalHeader();
  const footer = useGlobalFooter();
  useEffect(() => {
    setIsClient(true);
  }, []);

  const breadcrumbs = generateBreadcrumbs(seo, hero);
  return (
    <WebsiteLayout header={header} footer={footer} stickyHeader={stickyHeader}>
      <SEO {...pageSeo} />
      <SubNav
        slug={seo.pageUrl.charAt(0) !== '/' ? `/${seo.pageUrl}` : seo.pageUrl}
        data={subNavData}
        form={subNavForm}
        setStickyHeader={boolean => setStickyHeader(boolean)}
      />
      <Breadcrumbs
        breadcrumbs={breadcrumbs.data}
        absoluteMode={breadcrumbs.absolute}
        layout="marketingpro"
      />
      <MarketingProHero
        form={heroInlineMarketingForm}
        type="video-bottom"
        isMobile={isMobile}
        {...heroContent}
      />

      <MarketingProOverviewStats image={statsGraph.image} />
      {isMobile && isClient ? (
        featureCarouselContentData.map((rowContent, index) => {
          return (
            <MarketingProRowContent
              key={`row${index}`}
              type="carousel"
              backgroundColor="var(--dark-gray-color)"
              {...rowContent}
            />
          );
        })
      ) : (
        <MarketingProRowContentCarousel
          data={featureCarouselContentData}
          form={heroInlineMarketingForm}
          backgroundColor="var(--dark-gray-color)"
          isMobile={isMobile}
        />
      )}
      <MarketingProValueProp backgroundImage={valuePropBackground} />
      {overviewCopyImageSectionOneData.map((rowContent, index) => {
        return (
          <MarketingProRowContent key={`row${index}`} type="feature" contained {...rowContent} />
        );
      })}
      <MarketingProOverviewVideo
        author={videoData.author}
        quote={videoData.quote}
        mainSrc={videoData.videoSrc}
        logo={videoData.logo}
        logoAlt={videoData.logoAlt}
      />
      <RowContentBottom>
        {overviewCopyImageSectionTwoData.map((rowContent, index) => {
          return (
            <MarketingProRowContent
              key={`row${index}`}
              type="feature"
              backgroundColor="var(--dark-gray-color)"
              {...rowContent}
            />
          );
        })}
      </RowContentBottom>
      <RowContentCTA>
        <RowContent {...bottomForm} />
      </RowContentCTA>
    </WebsiteLayout>
  );
};

export default MarketingProOverview;

const RowContentBottom = styled.div`
  padding: 40px 0 120px 0;
  background: var(--dark-gray-color);

  @media (max-width: 576px) {
    padding: 40px 0 0 0;
  }
`;

const RowContentCTA = styled.div`
  @media (max-width: 576px) {
    .row-content--col {
      min-height: 150px;
    }
  }
`;
